<template>
    <div class="campaign-summary" @touchmove.prevent.stop>
        <transition name="fade" mode="out-in" v-if="info">
            <el-button v-if="buttonState == 0" @click="copy" size="mini" type="primary" round>{{ buttonText[buttonState] }}</el-button>
            <el-button v-else @click="copy" size="mini" type="success" round>
                {{ buttonText[buttonState] }}
            </el-button>
        </transition>
        <textarea ref="copyText" type="text" class="hidden" contenteditable="true">{{ copyText }}</textarea>
        <div v-loading="!info" class="summary">
            <transition-group name="fade">
                <el-card class="box-card" v-for="(step,key) in info" :key="key">
                    <h1>{{ stepTitles[key] }}</h1>
                    <div v-for="(val,field) in step" v-if="summaryTitles[field] && val && val.length > 0" :key="field" class="attribute">
                        <span class="field">{{summaryTitles[field]}}: </span>
                        <span class="value" v-if="!val || val.indexOf('http') !== 0">{{val}}</span>
                        <span class="value" v-else><a :href="val" target="_blank">{{val}}</a></span>
                    </div>
                </el-card>
            </transition-group>
        </div>
    </div>
</template>

<script>
export default {
  name: 'campaign-summary',
  props: ['name', 'campaign'],
  data() {
    return {
      info          : false,
      buttonState   : 0,
      buttonText    : ['Copy To Clipboard', 'Copied !'],
      buttonTimeout : null,
      stepTitles    : {
        'step1'     : 'Step 1',
        'step2'     : 'Step 2',
      },
      summaryTitles : { 
        'campaign_id'   : 'ID', 
        'campaign_name' : 'Name', 
        'cpa_out'       : 'CPA', 
        'redirect_link' : 'Link', 
        'product_image' : 'Assets'
      },
      mergeFields   : ['campaign_id', 'campaign_name', 'cpa_out']
    }
  },
  computed: {
    copyText() {
      return Object.keys(this.info).reduce((carry, step) => {
        return carry += (this.stepTitles[step] || step) + "\n" + Object.keys(this.info[step]).reduce((campaign, field) => {
          return campaign += this.summaryTitles[field] + ": " + this.info[step][field] + "\n"
        }, '') + "\n"
      }, '')
    }
  },
  watch: {
    campaign() {
      this.getSummary()
    },
    '$store.state.user.affiliate_id'() {
      this.getSummary()
    }
  },
  mounted() {
    this.getSummary()
  },
  methods: {
    getSummary() {
      this.info = false

      var apiEndpoint = this.$store.getters.affiliateBaseEndpoint + '/campaign/' + this.campaign + '/summary'
      this.$http.get(apiEndpoint, {requestId: 'campaign-summary', context: this._uid})
        .then((result) => {
          this.info = result.data.data

          if (this.info && this.info.step1) {
            this.stepTitles.step1 = 'Step 1';
            
            // Merge step1+ data into step1 data
            Object.keys(this.info).forEach((step) => {
              if (step !== "step1") {
                this.stepTitles.step1 += " / " + this.stepTitles[step];
                Object.keys(this.info[step]).forEach((field) => {
                  if (this.info[step][field] && this.mergeFields.includes(field))
                    this.info.step1[field] += " / " + this.info[step][field];
                })
                delete this.info[step]
              }
            })
          }
        }, () => {
          // 
        })
    },
    copy() {
      try {
        const copyText = this.$refs.copyText

        if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
          copyText.readOnly = true
          var range = document.createRange()
          range.selectNodeContents(copyText)
          var sel = window.getSelection()
          sel.removeAllRanges()
          sel.addRange(range)
          copyText.setSelectionRange(0, 999999)
          copyText.readOnly = false
        } else {
          copyText.select()
        }

        document.execCommand('copy')
        copyText.blur()

        this.buttonState = 1
        clearTimeout(this.buttonTimeout)
        this.buttonTimeout = setTimeout(() => {
          this.buttonState = 0
        }, 2500)
      } catch (err) {
        //
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.campaign-summary {
  h1 {
    font-size: 16px;
    margin-bottom: 16px;
  }
  .hidden {
    height: 0;
    overflow: hidden;
    opacity: 0;
    position: absolute;
    left: -10000px;
  }
  .summary {
      min-height: 150px;
  }
  .el-button {
    position: absolute;
    right: 16px;
    top: 10px;
    width: 160px;
    text-align: center;
  }
  .el-card {
    margin-bottom: 16px;
    padding: 25px;
  }
  .attribute {
    color: #555;

    a {
      color: #555;
    }

    span {
      overflow: hidden;
      text-overflow: ellipsis; 
      white-space: nowrap;
      vertical-align:middle;
      display: inline-block;
    }
  }
  .field {
    color: #000;
    width: 50px;
  }
  .value {
    width: 310px;
  }
}
@media(max-width: 450px) {
  .campaign-summary {
    .value {
      width: calc(100% - 55px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// campaign-summary.vue?5cfc63b2